import { Component, Input } from '@angular/core';
import { LoStatus } from 'lo-design-system';
import { IntegrationHealth } from '@brand-lolly/app/_models/brand-instagram-integration.model';

@Component({
	standalone: true,
	selector: 'meta-health-badge',
	imports: [LoStatus],
	template: `
		<lo-status dot [tone]="tone">{{ label }}</lo-status>
	`,
	styles: [
		`
			:host {
				display: flex;
				align-items: center;
			}
		`
	]
})
export class MetaHealthBadgeComponent {
	@Input() health: IntegrationHealth = 'ok';
	@Input() label = '';

	get tone(): 'success' | 'warning' | 'danger' | 'neutral' {
		switch (this.health) {
			case 'ok':
				return 'success';
			case 'expiring':
				return 'warning';
			case 'expired':
			case 'revoked':
				return 'danger';
			default:
				return 'neutral';
		}
	}
}
